import { useMemo, useState } from 'react';
import { STICKY_COLORS } from '@lumo/shared';
import { useTheme } from '@/lib/theme';
import { cn } from '@/lib/cn';

function hash(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619);
  return h >>> 0;
}

function rng(seed: number) {
  let x = seed || 1;
  return () => {
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    return ((x >>> 0) % 10000) / 10000;
  };
}

/** Миниатюра доски: настоящее превью или детерминированная «мини-доска» по id. */
export function BoardThumb({ id, src, className }: { id: string; src?: string | null; className?: string }) {
  const theme = useTheme((s) => s.resolved);
  const [failed, setFailed] = useState(false);
  const shapes = useMemo(() => {
    const r = rng(hash(id));
    const n = 3 + Math.floor(r() * 4);
    return Array.from({ length: n }, (_, i) => {
      const c = STICKY_COLORS[Math.floor(r() * STICKY_COLORS.length)]!;
      const kind = r() > 0.75 ? 'circle' : 'sticky';
      const size = 18 + r() * 16;
      return { i, x: 12 + r() * 64, y: 14 + r() * 52, size, rot: (r() - 0.5) * 12, color: theme === 'dark' ? c.dark : c.light, kind };
    });
  }, [id, theme]);

  if (src && !failed) {
    return (
      <div className={cn('relative overflow-hidden bg-canvas', className)}>
        <img src={src} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} className="size-full object-cover" draggable={false} />
      </div>
    );
  }
  return (
    <div className={cn('canvas-dots relative overflow-hidden', className)} aria-hidden>
      <svg viewBox="0 0 100 80" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 size-full">
        {shapes.map((s) =>
          s.kind === 'circle' ? (
            <circle key={s.i} cx={s.x + s.size / 2} cy={s.y + s.size / 2} r={s.size / 2.4} fill={s.color} stroke="rgb(28 25 23 / 0.15)" strokeWidth="0.6" />
          ) : (
            <g key={s.i} transform={`rotate(${s.rot} ${s.x + s.size / 2} ${s.y + s.size / 2})`}>
              <rect x={s.x + 0.6} y={s.y + 1.2} width={s.size} height={s.size} rx="1" fill="rgb(28 25 23 / 0.08)" />
              <rect x={s.x} y={s.y} width={s.size} height={s.size} rx="1" fill={s.color} />
              <rect x={s.x + s.size * 0.18} y={s.y + s.size * 0.35} width={s.size * 0.64} height={s.size * 0.08} rx="0.5" fill="rgb(28 25 23 / 0.18)" />
              <rect x={s.x + s.size * 0.18} y={s.y + s.size * 0.52} width={s.size * 0.44} height={s.size * 0.08} rx="0.5" fill="rgb(28 25 23 / 0.18)" />
            </g>
          ),
        )}
      </svg>
    </div>
  );
}
